import { useState } from "react";
import { useSelector } from "react-redux";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import { useAppDispatch } from "../../../../app/hooks";
import { SubjectPerformedInfo } from "../../../../redux/curriculum/model";
import { selectSubjectList } from "../../../../redux/curriculum/subjectListSlice";
import { subjectPerformedDelete } from "../../../../redux/curriculum/subjectPerformedInsUpdSlice";
import { subjectPerformedListSlice } from "../../../../redux/curriculum/subjectPerformedListSlice";

export interface SubjectPerformedDeleteModalProps {
    subjectPerformed: SubjectPerformedInfo | undefined;
    onClose: () => void;
}

export function SubjectPerformedDeleteModal({ subjectPerformed, onClose }: SubjectPerformedDeleteModalProps) {
    const dispatch = useAppDispatch();
    const subjects = useSelector(selectSubjectList);
    const [deleting, setDeleting] = useState(false);

    const subjectName = subjectPerformed
        ? (subjects.list?.find((s) => s.id == subjectPerformed.subjectId)?.name
            || `Disciplina ${subjectPerformed.subjectId}`)
        : "";

    return (
        <Dialog
            open={subjectPerformed !== undefined}
            onClose={() => {
                if (!deleting) {
                    onClose();
                }
            }}>
            <DialogTitle>Remover Aula Ministrada</DialogTitle>
            <DialogContent>
                <Typography>
                    Tem certeza que deseja remover a aula ministrada
                    {subjectPerformed && (
                        <>
                            {" "}<b>{subjectName}</b>
                        </>
                    )}
                    ?
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} disabled={deleting}>
                    Cancelar
                </Button>
                <Button
                    color="error"
                    variant="contained"
                    disabled={deleting}
                    onClick={async () => {
                        if (!subjectPerformed) {
                            return;
                        }
                        try {
                            setDeleting(true);
                            await dispatch(subjectPerformedDelete({ subjectPerformedId: `${subjectPerformed.id}` })).unwrap();
                            dispatch(subjectPerformedListSlice.actions.clean());
                            onClose();
                        } finally {
                            setDeleting(false);
                        }
                    }}>
                    Remover
                </Button>
            </DialogActions>
        </Dialog>
    );
}
